module.exports = __webpack_public_path__ + "static/media/Jamal.a34fc15a.jpg";